// Edit Website-Policies
export const UPDATE_WEBSITEPOLICIES = "UPDATE_WEBSITEPOLICIES";
export const UPDATE_WEBSITEPOLICIES_SUCCESS = "UPDATE_WEBSITEPOLICIES_SUCCESS";
export const UPDATE_WEBSITEPOLICIES_FAIL = "UPDATE_WEBSITEPOLICIES_FAIL";

//Fetch Website-Policies
export const FETCH_WEBSITEPOLICIES = 'FETCH_POLICIES';
export const FETCH_WEBSITEPOLICIES_SUCCESS = 'FETCH_POLICIES_SUCCESS';
export const FETCH_WEBSITEPOLICIES_FAIL = "FETCH_WEBSITEPOLICIES_FAIL";